<script>
export default {
  name: 'PageGuideDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue']
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="page-guide-dialog">
      <q-card-section class="row items-center justify-between q-py-sm">
        <div>
          <div class="text-subtitle1 text-weight-bold">{{ title }}</div>
          <div v-if="description" class="text-caption text-grey-7">{{ description }}</div>
        </div>
        <q-btn
          flat
          round
          dense
          icon="close"
          aria-label="가이드 닫기"
          @click="$emit('update:modelValue', false)"
        >
          <q-tooltip>닫기</q-tooltip>
        </q-btn>
      </q-card-section>
      <q-separator />
      <q-card-section class="page-guide-dialog__body">
        <slot />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.page-guide-dialog {
  width: min(980px, 94vw);
  max-width: 980px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.page-guide-dialog__body {
  overflow-y: auto;
}
</style>
